{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Du har överskridit konversationsgränsen. Hacker-planen tillåter endast 500 konversationer.",
      "INBOXES": "Du har överskridit inkorgsgränsen. Hacker-planen stöder endast live-chatt på webbplatsen. Fler inkorgar, som e-post, WhatsApp med mera, kräver en betald plan.",
      "AGENTS": "Du har överskridit agentgränsen. Hacker-planen tillåter endast 2 agenter.",
      "NON_ADMIN": "Kontakta din administratör för att uppgradera planen och fortsätta använda alla funktioner."
    },
    "TITLE": "Kontoinställningar",
    "SUBMIT": "Uppdatera inställningar",
    "BACK": "Tillbaka",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Kunde inte uppdatera inställningar, försök igen!",
      "SUCCESS": "Uppdaterade kontoinställningar"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Radera ditt konto",
      "NOTE": "När du raderar ditt konto raderas all din data.",
      "BUTTON_TEXT": "Radera ditt konto",
      "CONFIRM": {
        "TITLE": "Radera konto",
        "MESSAGE": "Att radera ditt konto är oåterkalleligt. Ange ditt kontonamn nedan för att bekräfta att du vill radera det permanent.",
        "BUTTON_TEXT": "Radera",
        "DISMISS": "Avbryt",
        "PLACE_HOLDER": "Vänligen skriv {accountName} för att bekräfta"
      },
      "SUCCESS": "Kontot har markerats för radering",
      "FAILURE": "Det gick inte att radera kontot, försök igen!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Det här kontot är schemalagt för radering den {deletionDate}. Detta begärdes av en administratör. Du kan avbryta raderingen före det datumet.",
        "MESSAGE_INACTIVITY": "Det här kontot är schemalagt för radering den {deletionDate} på grund av inaktivitet. Du kan avbryta raderingen före det datumet.",
        "CLEAR_BUTTON": "Avbryt schemalagd radering"
      }
    },
    "FORM": {
      "ERROR": "Vänligen åtgärda formulärfel",
      "GENERAL_SECTION": {
        "TITLE": "Allmänna inställningar",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Account ID",
        "NOTE": "This ID is required if you are building an API based integration"
      },
      "NAME": {
        "LABEL": "Kontonamn",
        "PLACEHOLDER": "Ditt kontonamn",
        "ERROR": "Ange ett giltigt kontonamn"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Ditt kontonamn",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Inkommande e-postdomän",
        "PLACEHOLDER": "Domänen du tar emot e-post på",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Supportmejl",
        "PLACEHOLDER": "Ditt företags supportmejl",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Antal dagar till ett ärende ska automatlösas på grund av inaktivitet",
        "NOTE": "Antal timmars inaktivitet innan en öppen konversation löses automatiskt.",
        "PLACEHOLDER": "30",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 day and maximum 999 days)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Antal dagar innan en tom konversation löses automatiskt om det inte finns någon aktivitet",
        "PLACEHOLDER": "aldrig",
        "ERROR": "Ange en giltig varaktighet för automatisk lösning av tomma konversationer (minst 1 dag och högst 999 dagar)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Konversationskontinuitet med e-post är aktiverat för ditt konto.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Du kan nu ta emot e-postmeddelanden i din egna domän."
      },
      "PHONE": {
        "TITLE": "PBX-inställningar",
        "NOTE": "Konfigurera anslutningen till din PBX för telefonsamtal",
        "SIP_HOST": {
          "LABEL": "SIP-domän"
        },
        "DIALING_MODE": {
          "LABEL": "Uppringningsläge",
          "MODES": {
            "direct": "Direkt - samtalet ringas omedelbart när du klickar på telefonlänken",
            "indirect": "Indirekt - telefonnumret förbereds i telefonwidgetens inmatningsfält"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Åtkomst till samtalsinspelningar",
          "MODES": {
            "admin_only": "Endast administratörer",
            "admin_and_assigned_agent": "Administratörer och tilldelad agent",
            "inbox_members": "Alla agenter med åtkomst till inkorgen"
          }
        }
      },
      "EMAIL": {
        "TITLE": "E-postinställningar",
        "NOTE": "Ändrar beteendet för e-postinkorgar"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Visningsläge för konversationens tidsstämpel",
        "MODES": {
          "both": "Skapad och senaste aktivitet",
          "last_activity_only": "Endast senaste aktivitet",
          "last_customer_message": "Senaste kundmeddelandet"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blockera domäner med lågt anseende"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Inkludera originalmeddelandet i svaret på e-posten"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Lös en ny konversation automatiskt"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Flytta automatiskt en ny e-postkonversation till inkorgen för den robot som hanterade kontaktens beställningar"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Utökade etiketter - Tillåt längre etikettnamn med ett större popup-gränssnitt"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Tilldela automatiskt konversationen till agenten som skickade det senaste svaret"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Läge för push-aviseringar",
        "MODES": {
          "all_inboxes": "Alla inkorgar - Skicka aviseringar för alla kanaltyper",
          "chat_only": "Endast chatt - Skicka endast aviseringar för icke-e-postkanaler"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Tillåt att signatur slås av/på för skickade meddelanden"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Visa agentens chattstatus på wallboarden"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Visa fullständiga bilagenamn utan avkortning"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Inloggning med lösenord",
        "MODES": {
          "allowed_for_all": "Tillåtet för alla användare",
          "allowed_for_agents_only": "Tillåtet endast för agenter (administratörer måste använda OAuth)",
          "password_login_disabled": "Inaktiverad - endast OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "En ny version är tillgänglig. Ladda om sidan för att få de senaste uppdateringarna.",
    "RELOAD_NOW": "Uppdatera nu",
    "LEARN_MORE": "Läs mer",
    "PAYMENT_PENDING": "Din betalning väntar. Uppdatera din betalningsinformation för att fortsätta använda kontaktcentret",
    "LIMITS_UPGRADE": "Ditt konto har överskridit användningsgränserna. Uppgradera din plan för att fortsätta använda kontaktcentret",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Tryck Enter för att välja",
      "ENTER_TO_REMOVE": "Tryck Enter för att ta bort",
      "NO_OPTIONS": "Listan är tom",
      "NO_RESULT": "Inga resultat hittades",
      "SELECT_ONE": "Markera en/ett",
      "SELECT": "Välj"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Aviseringar",
    "MARK_ALL_DONE": "Markera alla som klara",
    "DELETE_TITLE": "deleted",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Unread Notifications",
      "ALL_NOTIFICATIONS": "View all notifications",
      "LOADING_UNREAD_MESSAGE": "Loading unread notifications...",
      "EMPTY_MESSAGE": "You have no unread notifications"
    },
    "LIST": {
      "LOADING_MESSAGE": "Laddar aviseringar...",
      "404": "Inga aviseringar",
      "TABLE_HEADER": [
        "Namn",
        "Telefonnummer",
        "Konversationer",
        "Senast kontaktad"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Ny konversation",
      "conversation_assignment": "Konversationen tilldelad",
      "assigned_conversation_new_message": "Nytt meddelande",
      "participating_conversation_new_message": "Nytt meddelande",
      "conversation_mention": "Omnämning",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Refresh"
    },
    "CONNECTION_LOST": {
      "TITLE": "Anslutningen bröts",
      "DESCRIPTION": "Vi kunde inte nå servern. Kontrollera din anslutning och försök igen.",
      "RETRY": "Försök igen"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Search or jump to",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Rapporter",
      "CONVERSATION": "Conversation",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Change Assignee",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Change Team",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "EXECUTE_MACRO": "Kör makro",
      "ADD_LABEL": "Add label to the conversation",
      "REMOVE_LABEL": "Remove label from the conversation",
      "SETTINGS": "Inställningar",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "GO_TO_REPORTS_OVERVIEW": "Go to Reports Overview",
      "GO_TO_CONVERSATION_REPORTS": "Go to Conversation Reports",
      "GO_TO_AGENT_REPORTS": "Go to Agent Reports",
      "GO_TO_LABEL_REPORTS": "Go to Label Reports",
      "GO_TO_INBOX_REPORTS": "Go to Inbox Reports",
      "GO_TO_TEAM_REPORTS": "Go to Team Reports",
      "GO_TO_SETTINGS_AGENTS": "Go to Agent Settings",
      "GO_TO_SETTINGS_TEAMS": "Go to Team Settings",
      "GO_TO_SETTINGS_INBOXES": "Go to Inbox Settings",
      "GO_TO_SETTINGS_LABELS": "Go to Label Settings",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Go to Canned Response Settings",
      "GO_TO_SETTINGS_APPLICATIONS": "Gå till applikationsinställningar",
      "GO_TO_SETTINGS_ACCOUNT": "Go to Account Settings",
      "GO_TO_SETTINGS_PROFILE": "Go to Profile Settings",
      "GO_TO_NOTIFICATIONS": "Go to Notifications",
      "ADD_LABELS_TO_CONVERSATION": "Add label to the conversation",
      "ASSIGN_AN_AGENT": "Assign an agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assign a team",
      "EXECUTE_A_MACRO": "Kör ett makro",
      "MUTE_CONVERSATION": "Mute conversation",
      "UNMUTE_CONVERSATION": "Unmute conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Remove label from the conversation",
      "REOPEN_CONVERSATION": "Återöppna konversationen",
      "RESOLVE_CONVERSATION": "Lös konversationen",
      "SEND_TRANSCRIPT": "Send an email transcript",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "UNTIL_NEXT_REPLY": "Until next reply",
      "UNTIL_NEXT_WEEK": "Until next week",
      "UNTIL_TOMORROW": "Until tomorrow",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "klicka här"
  }
}
